import script from "./BlockIndividual.vue?vue&type=script&lang=js"
export * from "./BlockIndividual.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__